// ruokailu.js

// Define lunch data
const lunchData = [
    {
        day: "Lauantai 17.05.2025",
        locations: [
            {
                location: "U7 Joukkueet / Kokoustila 2.krs",
                lunchTimes: [
                    { time: "11:00", team: "Wolf Musta & Wolf Keltainen ", logoUrl: "https://files.eliteprospects.com/layout/logos/f667f640-87d9-4879-b248-dde1387fac00_large.png" },
                    { time: "11:00", team: "Kurra" , logoUrl: "https://sportti.org/site/assets/files/1298/kurra-2023-original.webp"},
                    { time: "11:00", team: "Haki Valkoinen",logoUrl: "https://static.jopox.fi/harjunkiekko/logos/logo-300.png"  },
                    { time: "11:20", team: "Kiekko Tiikerit",logoUrl: "https://kiekko-tiikerit.fi/wp-content/uploads/2020/12/tiikerit_logo_transparent_1600-1.png" },
                   

                    { time: "11:20", team: "HIFK Blue",logoUrl: "https://hifk.fi/wp-content/themes/hifk/assets/images/ifk.svg" },
                    { time: "11:30", team: "HIFK Red",logoUrl: "https://hifk.fi/wp-content/themes/hifk/assets/images/ifk.svg" },
                   
                    { time: "11:40", team: "HIFK White",logoUrl: "https://hifk.fi/wp-content/themes/hifk/assets/images/ifk.svg"},
                    { time: "11:40", team: "Haki Sininen", logoUrl: "https://static.jopox.fi/harjunkiekko/logos/logo-300.png"},
                    { time: "11:50", team: "HIFK Grey",logoUrl: "https://hifk.fi/wp-content/themes/hifk/assets/images/ifk.svg"},
                ]
            },
            {
                location: "U8 Joukkueet / 2.krs aula",
                lunchTimes: [
                    
                   
                    { time: "13:00", team: "Kiekko Tiikerit",logoUrl: "https://kiekko-tiikerit.fi/wp-content/uploads/2020/12/tiikerit_logo_transparent_1600-1.png" },
                    { time: "13:00", team: "HIFK Blue",logoUrl: "https://hifk.fi/wp-content/themes/hifk/assets/images/ifk.svg"  },
                    { time: "13:30", team: "KiVa Lohet & KiVa Taimenet ",logoUrl: "https://upload.wikimedia.org/wikipedia/fi/thumb/5/52/Kiekko-Vantaa_logo.svg/1200px-Kiekko-Vantaa_logo.svg.png"  },
                    { time: "14:00", team: "Wolf Musta & Wolf Keltainen",logoUrl: "https://files.eliteprospects.com/layout/logos/f667f640-87d9-4879-b248-dde1387fac00_large.png" },
        
                ]
            }
        ]
    },
    {
        day: "Sunnuntai 18.05.2025",
        locations: [
            {
                location: "U9 Joukkueet / Kokoustila 2.krs",
                lunchTimes: [
                    { time: "11:00", team: "HJK Blue & HJK White", logoUrl:"https://upload.wikimedia.org/wikipedia/commons/b/b1/Helsingin_J%C3%A4%C3%A4kiekkoklubi_logo.png" },
                    { time: "11:15", team: "Viikingit Red & Viikingit White",logoUrl: "https://upload.wikimedia.org/wikipedia/fi/e/e3/Viikingit_HC_logo.png" },
                    { time: "11:45", team: "Wolf Musta & Wolf Keltainen",logoUrl: "https://files.eliteprospects.com/layout/logos/f667f640-87d9-4879-b248-dde1387fac00_large.png" },
                    { time: "12:00", team: "Hunters White & Hunters Blue",  logoUrl: "https://static.jopox.fi/hunters/logos/logo-600.png" },
                    
                ]
            },
            {
                location: " U8 Joukkueet / 2.krs aula",
                lunchTimes: [
                    { time: "13:00", team: "K-Kissat Bears & K-Kissat Cats", logoUrl: "https://upload.wikimedia.org/wikipedia/fi/3/3f/Karhu-Kissat.png?20161030101639"  },
                    { time: "13:30", team: "K-Espoo Blue & K-Espoo White",logoUrl: "https://upload.wikimedia.org/wikipedia/en/thumb/2/23/Kiekko-Espoo_logo_2021.png/250px-Kiekko-Espoo_logo_2021.png" },
                    
                    { time: "14:00", team: "K-Espoo Yellow", logoUrl: "https://upload.wikimedia.org/wikipedia/en/thumb/2/23/Kiekko-Espoo_logo_2021.png/250px-Kiekko-Espoo_logo_2021.png" },
                    { time: "14:00", team: "Hunters",logoUrl: "https://static.jopox.fi/hunters/logos/logo-600.png"  },
                    { time: "14:30", team: "Wolf Keltainen & Wolf Musta", logoUrl: "https://files.eliteprospects.com/layout/logos/f667f640-87d9-4879-b248-dde1387fac00_large.png"  },
                ]
            }
        ]
    }
];

export default lunchData;
